module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pt1",
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "PART",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 17. ",
      "epub:type": "pagebreak",
      "id": "pg_17",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('span', {
    staticClass: "PT"
  }, [_vm._v("Formations")])])])]), _vm._v(" "), _c('p', {
    staticClass: "PST"
  }, [_c('i', [_vm._v("Slavery, Settlers, and Salvation")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The United States was formed in the midst of clashing European empires. White settler colonies, rooted in Christian identity and institutions of religious authority, were prizes for competing European empires, particularly France, Britain, and Spain. These settler colonies countered (and sometimes formed temporary alliances with) Indigenous polities that were fighting to preserve their lands and their sovereignty. When the new republic rebelled against the authority of the vast British Empire, it was at the same time establishing its own imperial status. And as these competing empires fought for control of territories such as the Great Lakes region, settler and missionary forms of Christianity interfaced with Indigenous and African religious traditions in many different ways. Christianity marked the imperial status of White settlers, legitimated their membership in the political community of the United States, and (through the Doctrine of Discovery) validated imperial claims to the land. In an expanding system of racial slavery, moreover, Africans and Indigenous Americans were racialized as “heathens” and relegated to highly vulnerable positions.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The British Caribbean, integral to the political and economic life of the early United States, intensified this demographic situation as a condition of empire. Jamaica transitioned from an Indigenous majority to a Black majority, following violent wars of extermination by European militarists and the forced displacement of abducted Africans into Jamaica as an enslaved labor force. During the 1700s, White Jamaican slaveholders were killing up to 20 percent of newly arrived Blacks within months by working them to death."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fm6-1",
      "id": "fm6_1",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" Jamaica was particularly shaped by numerous Black freedom wars and rebellions against such a murderous system of slavery. As African-derived and Christianized religions among Blacks were regularly implicated in rebellions and freedom wars, White slaveholders allied with "), _c('span', {
    attrs: {
      "aria-label": " Page 18. ",
      "epub:type": "pagebreak",
      "id": "pg_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("political elites to repress and even criminalize various formations of Black religion. Weaponizing religion as a means of racial and colonial control, thus, became a regular feature of American empire.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("From the 1700s to the early 1800s, the population of Whites in the United States grew from 3.1 million in 1790 to almost 20 million by 1850. Due to the overwhelming force of racial slavery, the African-descended population grew from about 760,000 to approximately 3.6 million in the same period. Despite being marginalized politically, Blacks were a significant population. Along the outskirts of the imperial republic and in many regions such as Mississippi, Florida, and Georgia, Indigenous Americans and Africans easily rivaled or outnumbered the White population. Native Americans—Choctaw, Chickasaw, and more—were the majority population in Mississippi until the US military violently forced them out of the state in the 1830s. At that point, Blacks became the majority and would remain so for another century. Not until the 1940s did White Mississippians constitute a majority of the state’s population. Creating free Black settlements through Black settler colonies in the Caribbean and in Africa—Liberia is perhaps the best-known instance—was an ongoing effort that promised an opportunity for free and enslaved Blacks to seek refuge from a White republic that opposed multiracial democracy while placating Whites who viewed Black freedom as a fundamental threat to the United States. It also became a central means for Black Christian missionary religion to emerge on a transnational scale. African American religion as we know it emerged within and often in opposition to this imperial frame.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Set on this broad historical stage, the three chapters in this section show how the imperial contests of the eighteenth and early nineteenth centuries (re)formed American religion. Rather than offering an exhaustive history, these chapters dig deeply into particular cases that open up much larger worlds. How did enslaved people, as well as slaveholders and imperial authorities, change what counted as “religion” in early America? How did US westward expansions and the rise of settler governance impact the definition and practices of both Indigenous and White settler religions? How did the imperial systems of settler colonialism also shape the history of African American religion?")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec3",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "ENH",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTE")])]), _vm._v(" "), _c('ol', {
    staticClass: "footnotes"
  }, [_c('li', [_c('p', {
    staticClass: "NTX"
  }, [_c('span', {
    staticClass: "en_tx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fm6_1",
      "id": "fm6-1"
    }
  }, [_vm._v("    1")])]), _vm._v("  Burnard, "), _c('i', [_vm._v("Jamaica in the Age of Revolution")]), _vm._v(", 92–93.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0